import axios from 'axios';
import { isTokenValid } from '../../../utils/index';

// Create an Axios instance with base URL and any other default config
const tenantAxiosInstance = axios.create();

// Add an interceptor to attach the authentication header
tenantAxiosInstance.interceptors.request.use((config) => {
  const authToken = JSON.parse(localStorage.getItem('brandUser'))?.access_token;
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
  return config;
});
const isProdEnv =
  process.env.REACT_APP_ENV === 'PRODUCTION' ||
  process.env.NODE_ENV === 'production' ||
  window.location.hostname === 'brandastra.ai';
  
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  console.log(pathSegments,isProdEnv,"isProdEnv");
  
tenantAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const authToken = JSON.parse(
      localStorage.getItem('brandUser')
    )?.access_token;

    if (!isTokenValid(authToken)) { 

      localStorage.removeItem('brandUser');
      localStorage.removeItem('persist:root');
      const loginRedirect = isProdEnv
        ? '/login'
        : pathSegments.length > 0
        ? `/${pathSegments[0]}/login`
        : '/login';

      window.location.href = loginRedirect;
    }
    return Promise.reject(error);
  }
);

export default tenantAxiosInstance;
